module.exports = __webpack_public_path__ + "img/picture_28.88d1f136.png";